export default __webpack_public_path__ + "static/media/animated_ashutosh.ce55eb26.png";